import { render, staticRenderFns } from "./DailyCloseAddRemarksPopup.vue?vue&type=template&id=354dea32&scoped=true&"
import script from "./DailyCloseAddRemarksPopup.vue?vue&type=script&lang=js&"
export * from "./DailyCloseAddRemarksPopup.vue?vue&type=script&lang=js&"
import style0 from "./DailyCloseAddRemarksPopup.vue?vue&type=style&index=0&id=354dea32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "354dea32",
  null
  
)

export default component.exports